import useAct from 'Workflows/hooks/useAct'

export default function useNodeSize(id) {
  const ref = useRef(null);
  const act = useAct()

  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      const borderBox = entries[0].borderBoxSize?.[0]
      const width = borderBox ? borderBox.inlineSize : entries[0].contentRect.width
      const height = borderBox ? borderBox.blockSize : entries[0].contentRect.height
      act.local.setNodeSize(id, { width, height })
    });
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, []); // Empty array means this effect runs once when the component mounts, and not on updates

  return ref
}

